"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Bubble = _interopRequireDefault(require("../Bubble"));

var HotelFact = function HotelFact(_ref) {
  var icon = _ref.icon,
      tooltip = _ref.tooltip,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    text: tooltip
  }, /*#__PURE__*/_react["default"].createElement(StyedHotelFact, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledIconWrapper, null, icon), /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label)));
};

var StyledIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardFact__StyledIconWrapper",
  componentId: "sc-1hc7rnc-0"
})(["position:relative;line-height:1;svg{width:60px;height:34px;stroke:", ";stroke-width:1;}span{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:14px;white-space:nowrap;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackBase;
});

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardFact__StyledLabel",
  componentId: "sc-1hc7rnc-1"
})(["font-size:14px;line-height:1;white-space:nowrap;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackBase;
});

var StyedHotelFact = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardFact__StyedHotelFact",
  componentId: "sc-1hc7rnc-2"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;"]);

HotelFact.propTypes = {
  className: _propTypes["default"].string,
  tooltip: _propTypes["default"].string.isRequired,
  icon: _propTypes["default"].node.isRequired,
  label: _propTypes["default"].string.isRequired
};
HotelFact.defaultProps = {
  className: ''
};

var _default = /*#__PURE__*/_react["default"].memo(HotelFact);

exports["default"] = _default;